<div class="row h-100 w-100 m-0">
	<div *ngIf="currentStep.stepId!=='0'" class="image-width p-0 " style="z-index: 3;">
		<div class="image-side" [style.backgroundImage]="'url(./assets/images/steps/'+selectImageUrl+')'"></div>
	</div>
	<div [ngClass]="currentStep.stepId==='0'?'w-100':'header-width'">
		<div class="d-flex flex-column">
			<div class="header-zone d-flex justify-content-cenetr w-lg-100 " [ngClass]="currentStep.stepId==='0'?'w-100':'header-width'">
				<div class="app-header" [ngClass]="currentStep.stepId==='0'?'mx-auto':''">

					<app-header></app-header>
					<div class="d-none d-md-flex flex-row mt-2 mr-1 row align-items-center">
						<app-step-indicator></app-step-indicator>
					</div>

					<div class="d-flex d-md-none flex-sm-row flex-column px-2 justify-content-between"
						style="background-color:white">
						<app-step-indicator></app-step-indicator>
					</div>
				</div>
			</div>

			<div [ngClass]="{'invisible':!showScrollHint}" class="scroll-hint d-flex justify-content-center"><i
					class="fa fa-chevron-up fa-2x " aria-hidden="true"></i></div>
		</div>
		<div class="content-zone" [ngClass]="{'q-focus':showScrollHint}">
			<router-outlet></router-outlet>
		</div>
	</div>

</div>


// WEBPACK FOOTER //
// ./src/app/mashkanta-questioner/mashkanta-questioner.component.html